<template>
  <div :class="$style.base">
    <div :class="$style.list">
      <NavItemMobile
        v-for="item in items"
        :key="item.routeName"
        :item="item"
        @click="$emit('navItemClick')"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import type { NavItem } from './MobileOverlay.vue';
import NavItemMobile from './NavItemMobile.vue';

defineProps<{
  items: NavItem[];
}>();
defineEmits(['navItemClick']);
</script>

<style
  lang="scss"
  module
>
.base {
  overflow: hidden;
  border-radius: $radius;
}

.list {
  display: flex;
  flex-direction: column;
  background: var(--surface-nav);
  border-radius: $radius;
  border: 1px solid var(--color-primary-dark);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);

  // Same as the desktop nav in dark mode
  @include theme('dark') {
    border-color: var(--border);
  }
}
</style>
